import * as React from 'react';
import Div from "@jumbo/shared/Div";
import InputIcon from 'app/components/InputIcon/InputIcon';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from "@mui/material";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useNavigate } from 'react-router-dom';
import DropdownInput from 'app/components/DropdownInput/DropdownInput';
import addLeadsSchema from './addLeadsSchema';
import { requestApi } from 'app/utils/RestApi';
import Swal from 'sweetalert2';
import { COMMON, LEADS } from 'app/utils/constants/endPoint';
import { Field, Formik } from 'formik';
import { Required } from 'app/utils/constants/validation';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { ERROR_SERVER_DEFAULT } from 'app/utils/appHelpers';

const MicrositeAddLeads = () => {
	const navigate = useNavigate()
	const userdata = localStorage.getItem('userdata')
	const [mstNeeds, setMstNeeds] = React.useState([])
	const [formData, setFormData] = React.useState({
		name: '',
		phone: '',
		email: '',
		gender: '',
		city: '',
		needId: null
	})

	const [fieldTouched, setFieldTouched] = React.useState({
		name: false,
		phone: false,
		email: false,
		gender: false,
		city: false,
		needId: false,
	});

	const [selectedNeed, setSelectedNeed] = React.useState({
		id: null,
		name: 'Pilih Kebutuhan'
	});

	const [canAddLeads, setCanAddLeads] = React.useState(true);

	React.useEffect(() => {
		initData()
	}, [])

	async function initData() {
		const ls_user = JSON.parse(userdata)
		const { referralStatus } = ls_user.userLoggedin.agent
		const res = await requestApi(COMMON.TNC_REFERRER, {
			subfolder: "/" + ls_user.userLoggedin.referrerCode
		})

		const isTerminated = referralStatus === 'TERMINATED';
		const hasAgreeTnc = res.data.data.hasAgreeTnc;
		let canAddL = hasAgreeTnc && !isTerminated;

		if (res?.data?.data) {
			setCanAddLeads(canAddL)
		}

		if (canAddL) {
			getNeed()
		} else {
			const message = isTerminated
				? 'Keanggotaan Anda telah dinonaktifkan. Anda tidak dapat menambahkan lead baru.'
				: 'Anda belum menyetujui Syarat & Ketentuan terbaru. Silakan setujui terlebih dahulu untuk dapat menambahkan lead.';
			Swal.fire({
				icon: 'warning',
				title: 'Akses Ditolak',
				text: message,
				confirmButtonText: 'Kembali',
			}).then(() => {
				navigate(-1);
			});
		}
	}

	const getNeed = async () => {
		await requestApi(COMMON.NEEDS).then(({ data }) => {
			if (data.status === 'success') {
				setMstNeeds(data.data)
			}
		}).catch(err => console.log(err))
	}

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	const navigateBack = () => {
		navigate('/micrositeListLeads');
	}

	const sendData = async (data) => {
		const dataLogin = JSON.parse(userdata)
		if (!dataLogin) {
			Swal.fire({
				icon: 'warning',
				text: 'Data referrer tidak ditemukan, silakan login kembali'
			})
			removeToken();
		}
		Swal.showLoading()
		await requestApi(LEADS.CREATE, {
			data: {
				...data,
				referrerId: dataLogin.userLoggedin.id
			}
		}).then(({ data }) => {
			Swal.close();
			if (data.status === 'success') {
				navigateBack();
				Swal.fire({
					icon: 'success',
					text: 'Data berhasil disimpan'
				});
			}
		}).catch(err => {
			Swal.close();
			console.log(err);
			Swal.fire({
				icon: 'warning',
				text: err?.message || ERROR_SERVER_DEFAULT,
				allowOutsideClick: false,
				confirmButtonColor: 'red'
			})
		})
	}

	const touchForm = (field) => {
		
		if (!fieldTouched[field]) {
			setFieldTouched((prevState) => ({ ...prevState, [field]: true }))
		}
	};

	return (
		<Div className='content-padding'>
			<Div className='back-icon'>
				<div onClick={navigateBack}><KeyboardBackspaceIcon /></div>
				<Div className='flex-justify-start' sx={{ marginLeft: '28px' }}>
					<img alt="" src={`${process.env.REACT_APP_IMAGES_PATH}/icons/ic-newleads.png`} width={18} height={20} />
					<Typography variant={"body1"} fontWeight={600} ml={1}>New Leads</Typography>
				</Div>
			</Div>
			<Div className='mt-5'>
				<Typography fontSize={24} fontWeight={700}>Silakan isi form di bawah ini untuk menambahkan lead baru</Typography>
				<Formik
					validateOnMount
					initialValues={formData}
					validationSchema={addLeadsSchema}
					onSubmit={(values) => {
						sendData(values)
					}}
				>
					{({ errors, values, handleSubmit, setValues }) => {
						function handleInputNeed(_, data) {
							setSelectedNeed(data)
							setValues({
								...values,
								['needId']: data.id
							})
						};
						return (
							<Div sx={{ mt: 1, mb: 3 }} className='form-layout'>

								<Row>
									<Col>
										<Field name="name">
											{({
												form: { handleChange },
												meta,
											}) => (
												<Div sx={{ mb: 4 }}>
													<InputIcon
														required
														type={'text'}
														inputLabel={"Nama Lengkap"}
														placeholder={"Nama Lengkap"}
														size={'small'}
														name={'name'}
														value={meta.value}
														onChange={handleChange}
														onBlur={() => touchForm('name')}
													/>
													{(fieldTouched.name && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											)}
										</Field>
									</Col>
									<Col>
										<Field name="email" sx={{ mb: 4 }}>
											{({
												form: { handleChange },
												meta,
											}) => (
												<Div sx={{ mb: 4 }}>
													<InputIcon
														type={'text'}
														size={'small'}
														name="email"
														inputLabel={"Alamat Email"}
														placeholder={"Alamat Email"}
														value={meta.value}
														onChange={handleChange}
														onBlur={() => touchForm('email')}
													/>
													{(fieldTouched.email && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											)}
										</Field>
									</Col>
								</Row>
								<Row>
									<Col>
										<Field name="city">
											{({
												form: { handleChange },
												meta,
											}) => (
												<Div sx={{ mb: 4 }}>
													<InputIcon
														required
														type={'text'}
														size={'small'}
														name="city"
														inputLabel={"Nama Kota"}
														placeholder={"Nama Kota"}
														value={meta.value}
														onChange={handleChange}
														onBlur={() => touchForm('city')}
													/>
													{(fieldTouched.city && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											)}
										</Field>
									</Col>
									<Col>
										<Field name="phone" sx={{ mb: 4 }}>
											{({
												form: { handleChange },
												meta,
											}) => (
												<Div sx={{ mb: 4 }}>
													<InputIcon
														required
														size={'small'}
														type={'tel'}
														name="phone"
														inputLabel={"Nomor Telepon Seluler"}
														placeholder={"628xxxxxxxxx"}
														notes={<small><b>contoh :</b> 6281234567890</small>}
														value={meta.value}
														onChange={handleChange}
														onBlur={() => touchForm('phone')}
													/>
													{(fieldTouched.phone && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											)}
										</Field>
									</Col>
								</Row>
								<Div>
									<Field name="gender">
										{({
											form: { handleChange },
											meta,
										}) => (
											<FormControl sx={{ mb: 3 }}>
												<Typography variant={"body1"} fontWeight={500} mb={1} fontSize={16}>Jenis Kelamin {Required}</Typography>
												<RadioGroup
													row
													aria-labelledby="demo-row-radio-buttons-group-label"
													name="gender"
													value={meta.value}
													onChange={handleChange}
													onBlur={() => touchForm('gender')}
												>
													<FormControlLabel value="M" control={<Radio />} label="Pria" />
													<FormControlLabel value="F" control={<Radio />} label="Wanita" />
												</RadioGroup>
												{(fieldTouched.gender && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
											</FormControl>
										)}
									</Field>
								</Div>
								<Field name="needId">
									{({
										form: { handleChange },
										meta,
									}) => (
										<Div sx={{ mb: 4 }}>
											<DropdownInput
												required
												data={mstNeeds}
												size={'small'}
												inputLabel={"Kebutuhan"}
												placeholder={"Pilih Kebutuhan"}
												name="mstNeeds"
												value={selectedNeed}
												onChange={handleInputNeed}
												onBlur={() => touchForm('needId')}
											/>
											{(fieldTouched.needId && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
										</Div>
									)}
								</Field>

								<Div className='flex-justify-center'>
									<ButtonStyled
										// disabled={!canSubmit && (Object.values(errors).length > 0)}
										onClick={handleSubmit}
										btnText={"Simpan"}
										preset={"primary"}
										sx={{ maxWidth: '451px' }}
									/>
								</Div>
							</Div>
						)
					}}
				</Formik>
			</Div>
		</Div>

	);
};

export default MicrositeAddLeads;